import { Injectable } from '@angular/core';
import { CaseSearchParams } from 'src/app/shared/models/cases/caseSearchParams';

@Injectable({
    providedIn: 'root'
})
export class FileFilterService {

    private _filters: CaseSearchParams;
    constructor() { }

    get filters(): CaseSearchParams {
        return this._filters;
    }

    set filters(params: CaseSearchParams) {
        this._filters = params;
    }

    resetParams() {
        this._filters = new CaseSearchParams();
    }
}
